import type { NamedExoticComponent } from "react";
import { createComponentRegistry } from "../../../../../shared-logic/features/ComponentRegistry";

const { ComponentRegistryProvider, useComponentRegistry } = createComponentRegistry<{
    CompareButton: NamedExoticComponent<{ gradeId: string; submodelId?: string }>;
    BackToModel: NamedExoticComponent;
}>();

export { ComponentRegistryProvider, useComponentRegistry };
